export const courseTabs = {
  adult: '成人',
  child: '少儿',
};

